export const labels = {
	name: {
		label: "Label.MobileCreator.PhotoInfo.Name",
		default: "Name",
	},
	fileSize: {
		label: "Label.MobileCreator.PhotoInfo.FileSize",
		default: "File size",
	},
	dimensions: {
		label: "Label.MobileCreator.PhotoInfo.Dimensions",
		default: "Dimensions",
	},
	dateTaken: {
		label: "Label.MobileCreator.PhotoInfo.DateTaken",
		default: "Date taken",
	},
	dateUploaded: {
		label: "Label.MobileCreator.PhotoInfo.DateUploaded",
		default: "Date uploaded",
	},
} as const;
